<div class="page">
  <div class="topbar-container">
    <app-besharp-topbar
      [title]="title"
      [logo]="logo"
      [stickyBar]="true"
      [height]="60"
      [scrollThreshold]="30"
      [homeRoute]="homeRoute"
      [topbarItems]="topBarItems"
    >
      <ng-template #topbarRightBefore>
        <button
          class="backend-health"
          [class.connected]="isBackendConnected"
          [class.disconnected]="!isBackendConnected"
          [class.checking]="isCheckingBackendHealth"
          (click)="refreshBackendHealth()"
          [title]="isBackendConnected ? 'Backend connected' : 'Backend disconnected'"
          type="button"
        >
          <span class="status-dot" aria-hidden="true"></span>
          <span class="status-label">{{ isBackendConnected ? 'Connected' : 'Disconnected' }}</span>
          @if (isCheckingBackendHealth) {
            <i class="pi pi-spin pi-spinner"></i>
          }
        </button>
      </ng-template>
    </app-besharp-topbar>
  </div>
  <div class="content-container" #contentContainer>
    <router-outlet></router-outlet>
  </div>
</div>
